import { tippy } from 'vue-tippy';

let instances = [];

/**
 * Initialize tooltips for elements with the class "tippy-table".
 */
function initializeTooltips(): void {
    instances = tippy('.tippy-table', {
        theme: 'tip-info',
        placement: 'bottom',
        interactive: true,
        appendTo: () => document.querySelector('.tooltip-append') as HTMLElement,
    });

    instances.forEach((instance) => {
        const id = instance.reference.getAttribute('data-template');
        const template = id ? document.getElementById(id) : null;
        if (template) {
            instance.setContent(template);
        }
    });
}

/**
 * Destroy all existing tooltips and reinitialize them after a table change.
 */
function handleTableChange(): void {
    instances.forEach((instance) => instance.destroy());

    setTimeout(() => {
        initializeTooltips();
    }, 10);
}

/**
 * Register the Livewire event listener for table changes.
 */
export function setupLivewireTooltips(): void {
    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.on('tableChanged', handleTableChange);
    }

    initializeTooltips();
}

setupLivewireTooltips();
